import { Icon } from 'antd-mobile';
import React from 'react'
import app from '../../pages/webgl/src/app.js'
import './optionBar.less'

class optionBar extends React.Component {

    state = {
        showSysNote: true,
        data: null,
        show: false,
        cnName: null,
        sysNote: null,
        canCancel: false,

        hideDone: false,
        hideOtherDone: false,
        opacityDone: false,
        opacityOtherDone: false,

        hideDisable: false,
        hideOtherhideDisable: false,
        opacityDisable: false,
        opacityOtherhideDisable: false

    }

    toggleShowSysNote() {
        this.setState({
            showSysNote: !this.state.showSysNote
        })
    }

    componentDidMount() {
        app.optionBar = this
        
    }

    resetOption() {
        this.setState({
            hideDone: false,
            hideOtherDone: false,
            opacityDone: false,
            opacityOtherDone: false,

            hideDisable: false,
            hideOtherhideDisable: false,
            opacityDisable: false,
            opacityOtherhideDisable: false,
            //检测返回按钮是否还存在上一步
            canCancel: app.opt.step.length
        })
    }

    upDateOptionBarState() {
        //先还原
        this.resetOption()
        if (!app.selectObj.length) return
        let item = app.selectObj[0]

        //如果当前选中的是单个group  或者length为1的数组
        if (item.type || item.length === 1) {

            if (item.length === 1) {
                item = item[0]
            }

            this.setState({
                opacityDone: item.opacity,
            })

            /*//上一步是隐藏其他
            if(this.state.hideOtherDone){
                this.setState({
                    //检测返回按钮是否还存在上一步
                    hideOtherDone:false
                })
            }
            */
            //如果当前选中是隐藏的，则操作其他按钮不可用
            /*if(!item.treeObj.checked){
                this.setState({
                    hideOtherhideDisable:true,
                    opacityOtherhideDisable:true
                })
            }*/

        }

        switch (app.preOpt) {

            case 'hideOption':
                this.setState({
                    hideDone: true,
                    opacityOtherhideDisable: true,
                    hideOtherhideDisable: true
                })
                break

            case 'hideOtherOption':
                this.setState({
                    hideOtherDone: true,

                    hideDisable: true,
                    opacityDisable: true,
                    opacityOtherhideDisable: true
          
                })
                break

            case 'opacityGroupOption':
                this.setState({
                    opacityDone: true   
                })
                break

            case 'opacityOtherGroupOption':
                this.setState({
                    opacityOtherDone: true
                })

                break

            case 'cancel':
                /*this.setState({
                    hideOtherhideDisable:true,
                    opacityOtherhideDisable:true
                })*/
                break

            default:
                break
        }

    }

    //隐藏
    hideOption() {
        if (this.state.hideDone) {
            this.cancel()
        } else {
            app.hideAndShowSelectObjGroupOption(false)
            app.preOpt = 'hideOption'
            this.upDateOptionBarState()
        }
    }


    //隐藏其他
    hideOtherOption() {
        if (this.state.hideOtherDone) {
            this.cancel()
        } else {
            console.log(23)
            app.hideAndShowOthterGroupOption(false)
            app.preOpt = 'hideOtherOption'
            this.upDateOptionBarState()
        }
    }

    //透明按钮
    opacityGroupOption() {
        if (this.state.opacityDone) {
            this.cancel()
        } else {
            app.opacityGroupOption(true)
            app.preOpt = 'opacityGroupOption'
            this.upDateOptionBarState()
        }
    }

    opacityOtherGroupOption() {
        if (this.state.opacityOtherDone) {
            this.cancel()
        } else {
            app.opacityOtherGroupOption(true)
            app.preOpt = 'opacityOtherGroupOption'
            this.upDateOptionBarState()
        }
        /*this.setState({
            opacityOtherDone:!this.state.opacityOtherDone
        })*/
    }

    cancel() {

        let preSelectObj = app.selectObj
        app.cancelOptionFn()
        app.preOpt = 'cancel'
        app.selectObj = preSelectObj

        for (let i = 0; i < app.selectObj.length; i++) {
            app.changeSelectDye(app.selectObj[i], true)
        }

        this.upDateOptionBarState()

        //如果退到底了就关闭操作面板
        if (!app.opt.step.length) {
            /*this.setState({
                show: false
            })*/
        }
        //如果当前选中是group
    }

    center(){
        app.resetControl()
    }

    //更新返回按钮状态

    render() {

        return (

            <div className = {this.state.show?'option-bar-wrap':'option-bar-wrap hide'}>

                <div className='infor-wrap'>

                    <div className='partNameWrap'  onClick = {this.toggleShowSysNote.bind(this)} >
                        <div className = {this.state.showSysNote?'active fa-tap-wrap toggle-tap':'fa-tap-wrap toggle-tap'}>
                            <i className='fa fa-angle-up'></i>
                        </div>
                        <div className='ShowName'>{this.state.cnName}</div>
                    </div>
      
                    {/*<div className='group-list-wrap'>
                        <div className='top-divide'></div>
                        <div className='group-wrap'></div>
                    </div>*/}

                    <div className= {this.state.showSysNote?"show-note show":"show-note"}>
                        <div className='top-divide'></div>
                        <div className='sysNote'>
                            <div className='text'>{this.state.sysNote}</div>
                        </div>
                    </div>

                </div>

                <div className="tip-tool" ref = { el => this.state.toolWrap = el} >

                    <div className='top-divide'></div>

                    <div className='list'>

                        <div className="option downOption">
   
                            <button onClick = {this.cancel.bind(this)}  disabled = {this.state.canCancel?'':'disabled'} className='tap cancel'></button>


                           {/* <button onClick = {this.hideOtherOption.bind(this)} disabled = {this.state.hideOtherhideDisable?'disabled':''} className='tap hideOtherTap'>
                                {this.state.hideOtherDone?'显示其他':'隐藏其他'}
                                <div className="tap-divide"></div>
                            </button>
*/}
                            <button onClick = {this.hideOption.bind(this)} disabled = {this.state.hideDisable?'disabled':''} className='shortTap tap hideTap'>
                                {this.state.hideDone?'显示':'隐藏'}
                                <div className="tap-divide"></div>
                            </button>


{/*
                            <button onClick = {this.opacityGroupOption.bind(this)} disabled = {this.state.opacityDisable?'disabled':''} className='shortTap tap opacityTap' >
                                {this.state.opacityDone?'实体':'透明'}
                                <div className="tap-divide"></div>
                            </button>

                            <button onClick = {this.opacityOtherGroupOption.bind(this)} disabled = {this.state.opacityOtherhideDisable?'disabled':''}  className='tap opacityOtherTap'>
                                {this.state.opacityOtherDone?'实体其他':'透明其他'}
                                <div className="tap-divide"></div>
                            </button>
*/}
                           

                            <button onClick = {this.center.bind(this)}  className='tap center'></button>

                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default optionBar


// WEBPACK FOOTER //
// ./src/components/optionBar/optionBar.jsx